/* eslint-disable @typescript-eslint/no-unused-vars */
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteAsset } from 'src/api/stoApi';

interface Props {
  assetId: string;
  open: boolean;
  handleClose: () => void;
  triggerRefresh: () => void;
  title: string;
}

export const DeleteAssetDialog: FC<Props> = ({ assetId, title, open, triggerRefresh, handleClose }) => {
  const { t } = useTranslation();
  const [dialogState, setDialogState] = useState<'init' | 'error' | 'success'>('init');
  const [error, setError] = useState<string>('');
  const [isLoading, setLoading] = useState(false);
  const handleCloseAndReset = () => {
    handleClose();
    setDialogState('init');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleCloseAndReset}>
      {dialogState === 'init' && (
        <>
          <DialogTitle>
            {t('dashboard.assets.dialog.deleteAsset.title')}: {' ' + title}
          </DialogTitle>
          <DialogContent>
            <Typography>{t('dashboard.assets.dialog.deleteAsset.body')}</Typography>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" onClick={handleCloseAndReset}>
              {t('dashboard.assets.dialog.deleteAsset.cancel')}
            </Button>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              disableElevation
              color="primary"
              onClick={async () => {
                setLoading(true);
                try {
                  const changeStatus = await deleteAsset(assetId);
                  if (changeStatus.data.status === 200) {
                    setDialogState('success');
                    triggerRefresh();
                  } else {
                    setDialogState('error');
                    setError(changeStatus.data.message);
                  }
                } catch (error: any) {
                  setDialogState('error');
                } finally {
                  setLoading(false);
                }
              }}
            >
              {t('dashboard.assets.dialog.deleteAsset.confirm')}
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
